export default __webpack_public_path__ + "machine-testimonials.gif";